export function getEstimateListId(est: any): number {
    return Number(est?.pfrEstimateId || est?.estimateId || 0);
}

export function getEstimateIocId(est: any): number {
    return Number(
        est?.estimateBody?.patientEncounterId ?? est?.patientEncounterId ?? 0
    );
}

function getEstimateCreateTime(est: any): number {
    const raw =
        est?.estimateBody?.createDt ??
        est?.createDt ??
        est?.estimateBody?.instanceCreateDt;
    return raw ? new Date(raw).getTime() : 0;
}

export function filterEstimatesByIoc(
    savedEstimations: any[] | null | undefined,
    selectedIocId: number | null | undefined
): any[] {
    if (!savedEstimations?.length) return [];
    if (!selectedIocId) return savedEstimations as any[];

    return (savedEstimations as any[]).filter(
        est => getEstimateIocId(est) === Number(selectedIocId)
    );
}

// Prefer IOC-tethered (pfrEstimateId), otherwise latest by createDt
export function pickEstimateForIoc(
    savedEstimations: any[] | null | undefined,
    selectedIocId?: number | null,
    linkedEstimateId?: number | null
): any | undefined {
    const filtered = filterEstimatesByIoc(savedEstimations, selectedIocId);
    if (!filtered.length) return undefined;

    if (linkedEstimateId) {
        const tethered = filtered.find(
            est => getEstimateListId(est) === Number(linkedEstimateId)
        );
        if (tethered) return tethered;
    }

    return [...filtered].sort((a, b) => {
        const byDate = getEstimateCreateTime(b) - getEstimateCreateTime(a);
        if (byDate !== 0) return byDate;
        return getEstimateListId(b) - getEstimateListId(a);
    })[0];
}
